export function formatDate(d) {
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
  const date = new Date(d);
  return date.toLocaleDateString('fr-FR', options);
}
